import { useState, useEffect } from "react";
import { getFiles } from "./ftpService";
import { FolderIcon, ChevronRightIcon, ChevronDownIcon } from "@heroicons/react/24/outline";

export default function FolderTree({ setCurrentPath, credentials }) {
  const [folders, setFolders] = useState([]);
  const [expandedFolders, setExpandedFolders] = useState({});

  useEffect(() => {
    console.log("📡 Credentials reçus dans FolderTree :", credentials);
    if (credentials?.username && credentials?.password) {
      fetchRootFolders();
    }
  }, [credentials]); // Rafraîchir si l'utilisateur change  

  const fetchRootFolders = async () => {
    if (!credentials) return;
    try {
      console.log("📡 Tentative de récupération des dossiers avec :", credentials);
      const files = await getFiles(credentials.host, credentials.username, credentials.password, "/");
      console.log("📁 Dossiers récupérés :", files);
      const directories = files.filter((file) => file.type === "d");
      setFolders(directories);
    } catch (error) {
      console.error("❌ Erreur lors du chargement des dossiers racine :", error);
    }
  };  

  const toggleFolder = async (path) => {
    if (!credentials) return;
  
    console.log("📂 Clic sur le dossier :", path);  // ✅ Vérifie si l’événement est bien déclenché
  
    if (expandedFolders[path]) {
      setExpandedFolders((prev) => ({ ...prev, [path]: false }));
    } else {
      try {
        console.log("🔄 Requête envoyée au backend pour :", path);
        const files = await getFiles(credentials.host, credentials.username, credentials.password, path);
        console.log("✅ Réponse reçue :", files);
  
        const directories = files.filter((file) => file.type === "d");
        setExpandedFolders((prev) => ({ ...prev, [path]: directories }));
      } catch (error) {
        console.error(`❌ Erreur lors du chargement des sous-dossiers de ${path} :`, error);
      }
    }
  };  

  return (
    <div className="bg-gray-100 p-3 rounded w-64">
      <h3 className="text-lg font-semibold mb-2">📁 Arborescence</h3>
      {credentials ? (
        <ul>
          {folders.map((folder) => (
            <FolderItem
              key={folder.path}
              folder={folder}
              toggleFolder={toggleFolder}
              expandedFolders={expandedFolders}
              setCurrentPath={setCurrentPath}
            />
          ))}
        </ul>
      ) : (
        <p className="text-red-500">🔑 Connectez-vous pour voir les dossiers</p>
      )}
    </div>
  );
}

function FolderItem({ folder, toggleFolder, expandedFolders, setCurrentPath }) {
  const isExpanded = expandedFolders[folder.path];

  return (
    <li className="ml-2">
      <button
        onClick={() => toggleFolder(folder.path)}
        className="flex items-center space-x-2 text-gray-800 hover:text-blue-600"
      >
        {isExpanded ? (
          <ChevronDownIcon className="w-4 h-4" />
        ) : (
          <ChevronRightIcon className="w-4 h-4" />
        )}
        <FolderIcon className="w-5 h-5 text-yellow-500" />
        <span onClick={() => setCurrentPath(folder.path)}>{folder.name}</span>
      </button>
      {isExpanded && (
        <ul className="ml-6">
          {Array.isArray(expandedFolders[folder.path]) &&
            expandedFolders[folder.path].map((subfolder) => (
              <FolderItem
                key={subfolder.path}
                folder={subfolder}
                toggleFolder={toggleFolder}
                expandedFolders={expandedFolders}
                setCurrentPath={setCurrentPath}
              />
            ))}
        </ul>
      )}
    </li>
  );
}
